import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorMessage } from 'app/core/error-handler/constants';
import { Error } from 'app/core/error-handler/models';
import { createErrorRaised } from 'app/core/error-handler/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { SiteLogoRestConnectorService } from '../services/site-logo-rest-connector.service';

import { SiteLogoActionType } from './actions/site-logo-action-type.enum';
import { DeleteSiteLogoCompleted, LoadSiteLogo, LoadSiteLogoCompleted } from './actions/site-logo.actions';

@Injectable()
export class SiteLogoEffects {
  public source: string = 'SiteLogoEffects';

  //// Site Logo ////
  @Effect()
  public loadSiteLogo$: Observable<Action> = this.actions$
    .pipe(
      ofType(SiteLogoActionType.LoadSiteLogo),
      switchMap(() => {
        return this._siteLogoConnector.loadSiteLogo().pipe(
          map((logoHref: string) => new LoadSiteLogoCompleted(logoHref)),
          catchError((err: any) => of(createErrorRaised(new Error({
            message: ErrorMessage.unexpected,
            errorResponse: err,
            source: this.source,
          })))),
        );
      }));

  @Effect()
  public deleteSiteLogo$: Observable<Action> = this.actions$
    .pipe(
      ofType(SiteLogoActionType.DeleteSiteLogo),
      switchMap(() => {
        return this._siteLogoConnector.deleteSiteLogo().pipe(
          switchMap(() => [new DeleteSiteLogoCompleted(),
            new LoadSiteLogo()]),
          catchError((err: any) => of(createErrorRaised(new Error({
            message: ErrorMessage.unexpected,
            errorResponse: err,
            source: this.source,
          })))),
        );
      }));

  constructor(private readonly actions$: Actions, private readonly _siteLogoConnector: SiteLogoRestConnectorService) {}
}
